import React from 'react'
import { Link, withPrefix } from 'gatsby'
import AuthWrapper, { Case, NoAuth, Else } from '../../components/AuthWrapper'
import Layout from "../../components/Layout"
import LikertWrapper, { JustHeader } from '../../components/LikertWrapper'

const termToNice = route => ['','Spring','','Summer','Fall'][route[4]] + ' ' + route.slice(0,4)
const collegeCodes = ['AS','CB','CM','ED','EG','HS','NU','SW', 'CCSS']

const ReportPage = ({ data, tables, solicited, route, year }) => !route ? <div/> : (
  <Layout>
    <h1>Advising Report: {termToNice(route)}</h1>
    <h4 style={{color:'#555'}}>
      {data.survey.totalCount.toLocaleString()} Responses / {solicited.toLocaleString()} Solicited
      <br/>
      <span className="footnote">{(data.survey.totalCount / solicited * 100).toFixed(2)}%</span>
    </h4>

  {tables.map((item, i) => 
    <div id={`q${item.n}`}>

      {(item.kind==='comment')
        ? <div id={item.code}>
            <h3 className="item-head">Question {item.n}.</h3>
            <p>{item.prompt}</p>
              <AuthWrapper>
                <Case test={auth => auth.hasRole('oira-admin') || auth.hasRole('advising-report-admin')}>
                    <a href={withPrefix(`/report/comment/${route}/${item.code}`)}>
                      View Comments
                    </a>
                </Case>
                <Case test={auth => auth.hasRole('dean') || auth.hasApp('advising-report')}>
                  {auth => 
                    <span>
                      <style jsx>{`
                        .aspan:not(:first-child)::before {
                          content: " | "
                        }
                      `}</style>
                      {collegeCodes
                          .filter(col => 
                            (auth['app-hierarchies']['advising-report'] || []).concat(auth.hierarchies).indexOf(`UA/${col}`)>-1
                            || auth.hasRole('oira-admin')
                          )
                          .map(col => 
                            <span key={col} className="aspan">
                              <a href={withPrefix(`/report/college_comment/${route}/${col}/${item.code}`)}>
                                View College ({col}) Comments &nbsp;
                              </a>
                            </span>
                          )
                      }
                    </span>
                  }
                </Case>
                <Else>
                  <p style={{color:'#777'}}>You have not been granted access to comments</p>
                </Else>
                <NoAuth>
                  <p style={{color:'#777'}}>comments are disabled unless authenticated</p>
                </NoAuth>
              </AuthWrapper>
             
          </div>

        : <div id={item.code}>
            <h3 className="item-head">{
              item.title || `Question ${item.n}.`
            }</h3>
            <LikertWrapper
              Q={item} 
              term={`Advising${route}`} 
              data={data.retabulateRoot.tabulations[item.prefix+route]}
            />
            {item.renderer!=='DemoTable' &&
              <AuthWrapper>
                 <Case test={auth => auth.hasRole('oira-admin') || auth.hasRole('advising-report-admin') }>
                  <a href={withPrefix(`/report/college/${route}/ALL/${item.code}`)}>
                    Detailed View
                  </a>
                </Case>
                <Case test={auth => auth.hasRole('dean') || auth.hasApp('advising-report')}>
                  {auth => 
                    <span>
                      <style jsx>{`
                        .aspan:not(:first-child)::before {
                          content: " | "
                        }
                      `}</style>
                      {collegeCodes
                          .filter(col => 
                            (auth['app-hierarchies']['advising-report'] || []).concat(auth.hierarchies).indexOf(`UA/${col}`)>-1
                            || auth.hasRole('oira-admin')
                          )
                          .map(col => 
                            <span key={col} className="aspan">
                              <a href={withPrefix(`/report/college/${route}/${col}/${item.code}`)}>
                                View College ({col}) Details &nbsp;
                              </a>
                            </span>
                          )
                      }
                    </span>
                  }
                </Case>
              </AuthWrapper>
            }
          </div>
      }
    </div>
  )}
  </Layout>
)

export default ReportPage
